import styled from "styled-components";

export const CandidateCVWrapper = styled.div``;

export const CVButtonsWrapper = styled.ul`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: -20px;
  width: 100%;
  left: 0;
  background: #f4f4f4;
  padding: 15px 0;
`;

export const CVButtonItem = styled.li`
  padding: 0 15px;

  svg {
    font-size: 1.8em;
    color: #f2008c;
    transition: 0.15s ease-in-out;
  }

  &.disabled {
    cursor: no-drop;

    svg {
      color: #c7c7c7;
    }

    &:hover {
      svg {
        cursor: no-drop;
        color: #c7c7c7;
      }
    }
  }

  &:hover {
    cursor: pointer;

    svg {
      color: #673490;
    }
  }
`;
